import type { SubPedido } from '../db/tipos'

// O estagio do PEDIDO inteiro, derivado das marcas. Um pedido pode ter marcas
// em estados diferentes (A faturada, B enviada), entao a lista precisa de uma
// regra -- e a regra dela (2026-07-30) e "mostre o que ainda pede acao".
export type Estagio = SubPedido['status']

// Ordem do ciclo da venda; cancelado e ramo lateral e fica no fim da lista.
export const ORDEM_ESTAGIO: ReadonlyArray<Estagio> = [
  'rascunho', 'fechado', 'enviado', 'faturado', 'entregue', 'pago', 'cancelado',
]

export const ROTULO_ESTAGIO: Record<Estagio, string> = {
  // "Rascunho" tambem era palavra de sistema: o pedido esta sendo montado.
  rascunho: 'Em andamento',
  // "Fechado" era palavra do codigo (o pedido foi fechado para montagem). Ela
  // trocou em 2026-07-30: o que importa nesse estagio e o que FALTA -- o PDF
  // da marca ainda nao foi compartilhado, entao a fabrica nem sabe do pedido.
  fechado: 'Não enviado',
  enviado: 'Enviado',
  faturado: 'Faturado',
  entregue: 'Entregue',
  pago: 'Pago',
  cancelado: 'Cancelado',
}

// Uma cor por estagio, para a tela responder antes da leitura. Ambar = espera
// alguma coisa dela; verde = ciclo fechado; vermelho = perdido. Os mesmos
// tons que o resto do app ja usa para essas ideias.
// Escolha dela em 2026-07-30: amarelo no "Nao enviado" (a fabrica ainda nem
// sabe do pedido -- e o que mais pede acao) e azul no "Faturado".
export const CLASSE_ESTAGIO: Record<Estagio, string> = {
  rascunho: 'bg-slate-100 text-slate-600',
  fechado: 'bg-yellow-100 text-yellow-800',
  // Roxo, e nao indigo: com o faturado em azul, os dois davam quase igual de
  // relance -- que e justamente quando a cor tem de servir.
  enviado: 'bg-purple-100 text-purple-800',
  faturado: 'bg-blue-100 text-blue-800',
  entregue: 'bg-teal-100 text-teal-800',
  pago: 'bg-emerald-100 text-emerald-800',
  cancelado: 'bg-red-100 text-red-700',
}

// O cartao inteiro pintado, nao so a tarja (pedido dela em 2026-07-30): de
// relance a lista ja se le por blocos de cor. Fundo bem claro para o texto
// escuro continuar legivel, e a faixa da esquerda mais forte para dar o tom.
// Um tom mais escuro em tudo (as cores claras sumiam na tela dela) e TRES tons
// no pago e no cancelado: sao os dois estagios que nao pedem mais analise, e o
// peso da cor e o que faz o olho pular por cima deles.
export const CLASSE_CARTAO_ESTAGIO: Record<Estagio, string> = {
  rascunho: 'bg-slate-100 border-slate-400',
  fechado: 'bg-yellow-100 border-yellow-500',
  // Um tom acima do azul do faturado, para separar por peso alem da matiz.
  enviado: 'bg-purple-200 border-purple-600',
  faturado: 'bg-blue-100 border-blue-500',
  entregue: 'bg-teal-100 border-teal-500',
  pago: 'bg-emerald-300 border-emerald-700',
  cancelado: 'bg-red-300 border-red-700',
}

// O MENOS avancado entre as marcas vivas: a lista e fila de trabalho, entao o
// pedido so sai de "Faturado" quando a ultima marca passar dali. Cancelada nao
// pesa (nao espera mais nada) -- a menos que TODAS estejam canceladas, e ai o
// pedido inteiro esta cancelado.
export function estagioDoPedido(subPedidos: SubPedido[]): Estagio {
  const vivos = subPedidos.filter((s) => s.apagado_em === null)
  if (vivos.length === 0) return 'rascunho' // pedido aberto ainda sem marca
  const emAndamento = vivos.filter((s) => s.status !== 'cancelado')
  if (emAndamento.length === 0) return 'cancelado'
  return emAndamento.reduce<Estagio>(
    (menor, sub) =>
      ORDEM_ESTAGIO.indexOf(sub.status) < ORDEM_ESTAGIO.indexOf(menor) ? sub.status : menor,
    'pago',
  )
}
